import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const ls = localStorage
const defaultBeacons = require('@/assets/beacons.json')
ls.setItem('beacons', JSON.stringify(defaultBeacons))
export default new Vuex.Store({
  state: {
    isLogged: false,
    beacons: defaultBeacons
  },
  mutations: {
    IS_LOGGED: (state, isLogged) => {
      state.isLogged = isLogged
    },
    BEACONS: (state, beacons) => {
      state.beacons = beacons
    }
  },
  actions: {
    login ({ commit }, isLogged) {
      ls.setItem('isLogged', isLogged)
      commit('IS_LOGGED', isLogged)
    },
    getLoggedState ({ commit }) {
      const loggedInState = ls.getItem('isLogged')
      const loggedIn = loggedInState === null ? false : JSON.parse(loggedInState)
      commit('IS_LOGGED', loggedIn)
    },
    getBeacons ({ commit }) {
      const storedBeacons = JSON.parse(ls.getItem('beacons'))
      if (storedBeacons) commit('BEACONS', storedBeacons)
    },
    setBeacons ({ commit }, beacons) {
      commit('BEACONS', beacons)
      ls.setItem('beacons', JSON.stringify(beacons))
    },
    addBeacon ({ commit }, beacon) {
      const beacons = JSON.parse(ls.getItem('beacons'))
      if (beacon.end_date) {
        beacon.status = 'picked'
      } else {
        beacon.status = 'placed'
      }
      let newBeacons = []
      if (beacons) {
        newBeacons = [...beacons, beacon]
      } else {
        newBeacons = [beacon]
      }
      commit('BEACONS', newBeacons)
      ls.setItem('beacons', JSON.stringify(newBeacons))
    }
  }
})
